import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { sportsList } from "../../utils/sportsType";
import { sportTypeMap } from "../../utils/sportsType";

export default function SpecificSportsFooter() {
  return (
    <>
      {sportsList.map((s, index) => (
        <React.Fragment key={s.key}>
          <Link to={`/${s.key}-${sportTypeMap[s.key]}-in-pune`}>
            {s.label} in Pune
          </Link>

          {/* Add spacer except for last item */}
          {index < sportsList.length - 1 && <span>&nbsp;|&nbsp;</span>}
        </React.Fragment>
      ))}
    </>
  );
}
